import '../../styles/FilterForArchive.css';
import Selector from '../CustomElements/Selector';
import Input from '../CustomElements/Input';
import { handleUniversalChange } from '../../utils/formUtils';

function FilterForArchiveKUOBZ({ formData, setFormData, t, options }) {
  return (
    <div className="filter-for-archive_select">
      <Input
        onChange={(event) => handleUniversalChange(formData, setFormData, event, null, null, null, null, null, 6)}
        value={formData?.mainKuobzId}
        name="mainKuobzId"
        label={t?.mainKuobzIdLabel || 'ID ведущего КУОБЗ'}
        placeholder={t?.mainKuobzIdPlaceholder || 'Введите ID КУОБЗ'}
        // type="number"
      />
      <Selector
        options={options?.alertType}
        onChange={(selectedOption) => {
          handleUniversalChange(formData, setFormData, null, 'kuobzAlertType', selectedOption, 'select');
        }}
        value={
          formData.kuobzAlertType || formData.kuobzAlertType === 0
            ? options?.alertType?.find((option) => option.value === formData.kuobzAlertType)
            : ''
        }
        name="kuobzAlertType"
        isMulti={false}
        label={t?.kuobzAlertTypeLabel || 'Сигнал на КУОБЗ'}
        placeholder={t?.alertTypePlaceholder || 'Выберите сигнал'}
      />
      <Selector
        options={options.safeZoneType}
        onChange={(selectedOption) => {
          handleUniversalChange(formData, setFormData, null, 'safeZoneType', selectedOption, 'select');
        }}
        value={
          formData?.safeZoneType || formData?.safeZoneType === 0
            ? options.safeZoneType?.find((option) => option.value === formData?.safeZoneType)
            : ''
        }
        name="safeZoneType"
        isMulti={false}
        label={t?.safeZoneTypeLabel || 'Форма безопасной зоны'}
        placeholder={t?.safeZoneTypePlaceholder || 'Выберите форму'}
      />
      <Input
        onChange={(event) => handleUniversalChange(formData, setFormData, event)}
        value={formData.safeZoneWidth}
        name="safeZoneWidth"
        label={t?.safeZoneWidthLabel || 'Ширина безопасной зоны'}
        placeholder={t?.safeZoneWidthPlaceholder || 'Введите ширину в метрах'}
      />
      <Input
        onChange={(event) => handleUniversalChange(formData, setFormData, event)}
        value={formData?.kuobzGPS}
        name="kuobzGPS"
        label={t?.amountGPSLabel || 'Количество спутников'}
        placeholder={t?.amountGPSPlaceholder || 'Введите количество спутников'}
      />
      <Selector
        options={options?.gsm}
        onChange={(selectedOption) => {
          handleUniversalChange(formData, setFormData, null, 'kuobzGSM', selectedOption, 'select');
        }}
        value={formData.kuobzGSM ? options?.gsm?.find((option) => option.value === formData.kuobzGSM) : null}
        name="kuobzGSM"
        isMulti={false}
        label={t?.signalLevelLabel || 'Уровень сигнала сотовой связи'}
        placeholder={t?.signalLevelPlaceholder || 'Выберите уровень сигнала'}
      />
      <Selector
        options={options?.connect}
        onChange={(selectedOption) => {
          handleUniversalChange(formData, setFormData, null, 'kuobzConn', selectedOption, 'select');
        }}
        value={
          formData.kuobzConn || formData.kuobzConn === false
            ? options?.connect?.find((option) => option.value === formData.kuobzConn)
            : ''
        }
        name="kuobzConn"
        isMulti={false}
        label={t?.connectLabel || 'Связь с сервером'}
        placeholder={t?.connectPlaceholder || 'Выберите наличие связи'}
      />
    </div>
  );
}

export default FilterForArchiveKUOBZ;
